export const Variables = {
    montserrat: 'Montserrat, sans-serif',
    assistant: 'Assistant, sans-serif',
};
